var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"follow"}},[_c('p',[_vm._v("作品为正版授权小说")]),_c('p',[_vm._v("通过服务号为您提供更多的阅读服务")]),_c('p',[_vm._v("请关注作者授权的公众号继续阅读")]),(_vm.cover)?_c('img',{attrs:{"src":'http://open.weixin.qq.com/qr/code?username=' + _vm.cover,"alt":""}}):_vm._e(),_c('p',[_vm._v("长按上图识别二维码关注")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('span',[_vm._v("关注后，点击阅读历史即可继续阅读")])])
}]

export { render, staticRenderFns }